export enum AppRoutes {
  Landing = '',
  Login = 'login',
  Tabs = 'tabs',
  Webflow = 'webflow',
}
